<template>
     <main-layout> 
        <div class="container azSize has-text-dark">
            <div class="is-size-3"><b>Try</b></div>
            <div>You can try the slink <span class=""><b>{{tgtSlink}}</b></span> for 14 days. The slink will expire after this period</div>
            
           <div class="top20">
                <div v-show="!$root.isAuth && !trialed && !sentEmail && !exists">
                    <div >Enter your email address to continue, we will send you a link to set up your slink</div>
                    <input class="input has-background-dBlue"   type="text" v-model="email"/><br>
                    <button class="button is-warning" @click="go">GO</button>
                </div>
    
                <div v-show="exists">
                    We found an account under this email address, please log in to continue.<br>
                    <button class="button is-warning">Log In</button>
                </div>
    
                <div v-show="trialed">
                    This email address has already tried the Slink <b>{{tgtSlink}}</b>. If you want to continue using it, please register and purchase a subscription for it.<br>
                    <button class="button is-warning">Register</button>
                </div>
    
                <div v-show="sentEmail">
                    Please check your email! We have sent you instructions on how to set up your slink trial.
                </div>
           </div>

            <div v-show="$root.isAuth" class="top10">
                <b>Logged in flow</b>
            </div>





        </div>
     </main-layout>
</template>

<script>
import MainLayout from '../layouts/Main.vue'
export default {
    components: {MainLayout},
    data: function(){
        return {
            email: null,
            trialed: false,
            sentEmail: false,
            exists: false,
            tgtSlink: this.$route.query.s
        }
    },

    mounted: function() {
        //TODO sanitize query slink
    },

    methods: {
        
        go: async function(){
            var self = this
            function w(d){
                if(d.data == 'exists'){
                    self.exists = true
                } else if(d.data == 'not exists'){
                    if(d.restricted){
                       self.trialed = true
                    } else {
                       self.sentEmail = true
                    }
                } else if(d.data == 'taken'){
                    self.$root.showModalOK({message: 'Sorry, another customer beat you to this slink. They are going fast! Please try another one.'})
                    self.$router.push('/')
                } else {
                    self.$root.showModalOK({message: 'Sorry, there was en error processing your request.'})
                }
            }
            function n(e){
              
            }
        
            var self = this;
            this.$root.apiClient.post('api/account/chkacc', {email: this.email, slink: this.tgtSlink}, w, n)
        },
        
        doIt: function(){
            var self = this;
            function w(d){

            }
            function n(){

            }
            this.$root.apiClient.post('api/account/trial/', {}, w, n)
        }
    }
}

</script>


// WEBPACK FOOTER //
// src/pages/Try.vue